import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import merge from 'lodash/merge';

import { BRANDING } from '@/config/branding';
import { LANGUAGES } from './languages';
import en from './general.json';
import he from './general_hebrew.json';
import unbrandedEn from './unbranded/general.json';
import unbrandedHe from './unbranded/general_hebrew.json';

export type I18Payload = [string, Record<string, string | number>?];

// In unbranded mode (SPX-6494), overlay neutral copy on every string whose
// value contains user-visible SpecterX branding.
const isUnbranded = BRANDING === 'unbranded';
const enResources = isUnbranded ? merge({}, en, unbrandedEn) : en;
const heResources = isUnbranded ? merge({}, he, unbrandedHe) : he;

i18next
    .use(initReactI18next)
    .init({
        resources: {
            [LANGUAGES.en]: { common: enResources },
            [LANGUAGES.he]: { common: heResources },
        },
        ns: ['common'],
        defaultNS: 'common',
        lng: LANGUAGES.en,
        interpolation: {
            escapeValue: false,
            skipOnVariables: false,
        },
    });

export default i18next;
